module.exports = __webpack_public_path__ + "3d803e82bffa516378aa4cf1512a8198.png";